module.exports = __webpack_public_path__ + "img/5.e1705a95.png";